import React, { useEffect } from "react";
import { useGetDimensions } from "../../Hooks/useGetDimension";
import './style.css'
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { SET_TOKEN_MIS } from "../../Redux/PolicyNumber/types";

const HeaderWrapper = styled.div`
height: 50px;
padding: 10px;
background-color: #0184c9 ;
top: ${(props) => props.top};
left: 0;
width: 100%;
z-index: 2
`

const Header = () => {
    const dispatch = useDispatch();
    const { tokenMis } = useSelector((state) => state.policyDetails);
    const headerHeight = useGetDimensions('header', 0).height
    const navigate = useNavigate()
    useEffect(() => {
        if (tokenMis == "null" || !!!tokenMis) {
            navigate('/login')
        }
    }, [])
    const onLogout = () => {
        if (tokenMis) {
            dispatch({type: SET_TOKEN_MIS, payload : null})
            navigate(-1)
        }
    }
    return (
        <HeaderWrapper top={headerHeight}>
            <div className="container header_container">
                <div className="header_image">
                    {/* <img src={Logo} /> */}
                </div>
                <div className="logout" onClick={() => onLogout()}>
                    <label className={"cls_mghunqzg_b73e01"}>Logout &nbsp;</label>
                    <FontAwesomeIcon icon={faPowerOff} color="white" />
                </div>
            </div>
        </HeaderWrapper>
    );
}
export default Header